import _ from 'underscore';
import $ from 'jquery';
import { DeterministicView, helpers } from '@bingads-webui/deterministic-view';
import { withUiBlock } from '@bingads-webui/uiblocker';
import {
  createCampaignAdGroupSelector,
} from '@bingads-webui-campaign-react/campaign-adgroup-selector-control';
import { DeterministicWrapperView } from '@bingads-webui/deterministic-wrapper-view';

import template from './add-keyword-template.pug';

const { ensureChildView } = helpers;

class CampaignAdgroupSelectorVnext extends DeterministicWrapperView {
  viewFactory({
    level,
    scope,
    campaignId,
    selectedCampaign,
    selectedAdGroup,
    jsData,
    i18n,
    edmCampaign,
  }) {
    this.campaignAdgroupSelector = createCampaignAdGroupSelector({
      jsData,
      edmCampaign,
      scope,
      level,
      campaignId,
      i18n,
      selectedCampaign,
      selectedAdGroup,
      parentView: this,
    });
    return this.campaignAdgroupSelector;
  }
}

/* @this AddKeywordView */
function setPosition() {
  const position = this.gridCard.$('.viewport').offset();

  if (!position) {
    return;
  }

  const offset = this.addAsNegativeKeyword ? 150 : 50;
  const top = position.top - offset - $(window).scrollTop();
  const left = position.left - $(window).scrollLeft();

  this.$el.css({
    top,
    left,
  });
}

/* @this AddKeywordView */
function updateSelectorPosition() {
  // Update position of campaign adgroup popup,
  // so that it's in view.
  const $selector = this.$('.ba-campaign-adgroup-selector .dropdown-menu, .ba-campaign-selector .dropdown-menu, .ba-campaign-selector .dropdown-menu');
  const $pageContainer = $('.overview-page');

  $selector.css({ top: 'auto', left: 'auto' });
  const { top, left } = $selector.offset();
  const { top: parentTop, left: parentLeft } = $selector.offsetParent().offset();
  const { top: pageContainerTop, left: pageContainerLeft } = $pageContainer.offset();
  const pageContainerHeight = $pageContainer.height();
  const pageContainerWidth = $pageContainer.width();
  const { selectionLevel } = this.getState();
  const selectingCampaignAndAdGroup = selectionLevel === 'adGroupLevel' && this.navigationLevel === 'account';
  const selectorSize = selectingCampaignAndAdGroup ?
    { height: 450, width: 620 } : { height: 450, width: 320 };

  const offset = { top: 'auto', left: 'auto' };

  if ((top - pageContainerTop) + selectorSize.height > pageContainerHeight) {
    offset.top = Math.max(
      (pageContainerHeight + pageContainerTop) - selectorSize.height - parentTop,
      pageContainerTop - parentTop
    );
  }

  if ((left - pageContainerLeft) + selectorSize.width > pageContainerWidth) {
    offset.left = Math.max(
      (pageContainerWidth + pageContainerLeft) - selectorSize.width - parentLeft,
      pageContainerLeft - parentLeft
    );
  }

  if (offset.top !== 'auto' || offset.left !== 'auto') {
    $selector.css(offset);
  }
}

/* @this AddKeywordView */
function clearError() {
  const { errMsg } = this.getState();

  if (errMsg) {
    this.setState({ errMsg: null });
  }
}

/* @this AddKeywordView */
function setupSelectorView() {
  const { selectionLevel, adGroupName, campaignName } = this.getState();
  const state = {
    scope: this.navigationLevel,
    level: selectionLevel,
    campaignId: this.campaignId,
    i18n: this.deps.i18n,
    selectedCampaign: {
      name: campaignName,
      Id: this.campaignId,
    },
    selectedAdGroup: {
      name: adGroupName,
      campaignName,
    },
    jsData: this.deps.jsdata,
    edmCampaign: this.deps.edmCampaign,
  };

  if (this.getChild('selector')) {
    this.detachChild('selector').remove();
  }

  const childView = ensureChildView(
    this,
    'selector',
    CampaignAdgroupSelectorVnext,
    state,
    {
      campaignSelected(newCampaign) {
        const { level = selectionLevel } = this.getState();

        if (level === 'campaignLevel') {
          this.campaignId = newCampaign.Id;

          this.setState({
            campaignName: newCampaign.Name,
          });
          clearError.call(this);
        }
      },
      adgroupSelected(newAdGroup) {
        this.campaignId = newAdGroup.campaignId;
        this.adGroupId = newAdGroup.Id;
        this.setState({
          adGroupName: newAdGroup.Name,
          campaignName: newAdGroup.campaignName,
        });
        clearError.call(this);
      },
    }
  );

  childView.once('rendered', () => {
    window.addEventListener('click', this.windowClickHandler);
    window.addEventListener('scroll', this.windowScrollHandler);
    window.addEventListener('resize', this.windowResizeHandler);
    $('.overview-page').parent().scroll(this.windowScrollHandler);
    updateSelectorPosition.call(this);
  });
}

/* @this AddKeywordView */
function errorHandler(response) {
  if (response && response.errors) {
    let errors;

    if (this.addAsNegativeKeyword) {
      errors = this.deps.i18nErrors.getODataErrors(response.errors);
    } else {
      errors = this.deps.i18nErrors.getBulkApiErrors(response.errors);
    }

    if (errors && errors[0] && errors[0].message) {
      this.setState({
        errMsg: errors[0].message,
      });
      return true;
    }
  }

  return false;
}

export class AddKeywordView extends DeterministicView {
  get className() {
    return 'add-keyword-container';
  }

  get template() {
    const {
      adGroupName,
      campaignName,
      selectionLevel,
      errMsg,
      isEmpty,
    } = this.getState();

    return () => template({
      i18n: this.deps.i18n,
      text: this.text,
      matchType: this.matchType,
      navigationLevel: this.navigationLevel,
      addAsNegativeKeyword: this.addAsNegativeKeyword,
      adGroupName,
      campaignName,
      selectionLevel,
      appendLearnMoreLink: this.deps.appendLearnMoreLink,
      errMsg,
      isEmpty,
    });
  }

  initialize({
    campaignId,
    adGroupId,
    text,
    navigationLevel,
    campaignName,
    adGroupName,
    gridCard,
    addAsNegativeKeyword,
    matchType,
    reloadGrid,
    deps,
  }) {
    this.campaignId = campaignId;
    this.adGroupId = adGroupId;
    this.text = text;
    this.reloadGrid = reloadGrid;
    this.deps = deps;

    if (addAsNegativeKeyword && matchType === 'Broad') {
      // Negative keyword do not have 'Broad' match, while delivery match type is 'Broad'.
      // Set default negative keyword match type as 'Exact'.
      this.matchType = 'Exact';
    } else if (!addAsNegativeKeyword && matchType === 'Exact') {
      // The delivery match type is 'Broad'. So the keyword already exist with 'Exact' match.
      // Set default new keyword match type as 'Broad'.
      this.matchType = 'Broad';
    } else {
      this.matchType = matchType;
    }

    this.navigationLevel = navigationLevel;
    this.gridCard = gridCard;
    this.addAsNegativeKeyword = addAsNegativeKeyword;
    gridCard.trigger('clearDragAndDrop');
    this.windowClickHandler = event => this.hideOnClickOutSide(event);
    this.windowScrollHandler = _.throttle(() => {
      this.updatePosition();
    }, 10);

    this.windowResizeHandler = _.throttle(() => {
      this.updatePosition();
    }, 10);
    this.scopeContext = this.deps.scopeService.getScope();

    setPosition.call(this);
    this.setState({
      adGroupName,
      campaignName,
      selectionLevel: 'adGroupLevel',
      isEmpty: false,
    });

    setupSelectorView.call(this);
  }

  onSuccess() {
    this.reloadGrid();
    this.remove();
  }

  onError(response) {
    if (!errorHandler.call(this, response)) {
      this.remove();
    }
  }

  cancel() {
    this.remove();
  }

  apply() {
    if (this.addAsNegativeKeyword) {
      const { selectionLevel } = this.getState();
      const negativeKeyword = {
        NegativeKeywords: [{
          Text: this.text,
          EntityType: selectionLevel === 'adGroupLevel' ? 'AdGroup' : 'Campaign',
          CampaignId: this.campaignId,
          AdGroupId: this.adGroupId,
          MatchType: this.matchType,
        }],
      };
      const campaignEntity = this.deps.edmCampaign.currentAccount.Campaigns
        .$withKey(this.campaignId);
      let entitySet;

      if (selectionLevel === 'adGroupLevel') {
        entitySet = campaignEntity.AdGroups.$withKey(this.adGroupId);
      } else {
        entitySet = campaignEntity;
      }

      this.deps.jsdata.NegativeKeyword.create(negativeKeyword, {
        entitySet: entitySet.NegativeKeywords['Default.PostNegativeKeywords'],
      }).finally(document.documentElement.contains(this.el) ?
        withUiBlock(this.el) :
        _.noop).then(() => this.onSuccess()).catch(response => this.onError(response));
    } else {
      const { adGroupName } = this.getState();
      const keywordData = {
        Campaign: { Id: this.campaignId },
        Name: adGroupName,
        Id: this.adGroupId,
        Keywords: [{
          Text: this.text,
          MatchType: this.matchType,
          Bid: {},
          AdGroup: { Id: this.adGroupId },
        }],
      };

      this.deps.jsdata.AdGroup
        .update(keywordData.Id, keywordData, { adapter: 'bulk' })
        .finally(document.documentElement.contains(this.el) ?
          withUiBlock(this.el) :
          _.noop).then(() => this.onSuccess()).catch(response => this.onError(response));
    }
  }

  updatePosition() {
    setPosition.call(this);
    updateSelectorPosition.call(this);
  }

  toggleSelector() {
    if (this.$('.popover.row.fade.bottom:visible').length === 0) {
      _.defer(() => {
        this.$('div.form-control.dropDownSelect.k-button.clickable').click();
      });
    }
  }

  updateEntityLevel(event) {
    const selected = this.$('input[type="radio"][name="entityLevel"]:checked');

    if (selected.length > 0) {
      const { selectionLevel } = this.getState();
      const value = selected.val();

      if (selectionLevel !== value) {
        this.setState({
          selectionLevel: value,
        });
        setupSelectorView.call(this);
        clearError.call(this);
      }
    }
    event.stopPropagation();
    event.preventDefault();
  }

  keywordTextChange() {
    this.text = this.$('input.keyword-text__value').val();
    clearError.call(this);
    this.setState({
      isEmpty: !this.text,
    });
  }

  matchTypeChange() {
    this.matchType = this.$('select.match-type__value').val();
    clearError.call(this);
  }

  get events() {
    return {
      'click button.cancel': this.cancel,
      'click button.apply': this.apply,
      'click .selected-entity-names': this.toggleSelector,
      'click input[type="radio"][name="entityLevel"]': this.updateEntityLevel,
      'input input.keyword-text__value': this.keywordTextChange,
      'change select.match-type__value': this.matchTypeChange,
      'click .ba-campaign-adgroup-selector, .ba-campaign-selector, .ba-campaign-selector': () => _.defer(updateSelectorPosition.bind(this)),
    };
  }

  remove() {
    this.gridCard.trigger('setupDragAndDrop');
    window.removeEventListener('click', this.windowClickHandler);
    window.removeEventListener('scroll', this.windowScrollHandler);
    window.removeEventListener('resize', this.windowResizeHandler);
    super.remove();
  }

  hideOnClickOutSide(event) {
    if (!this.el.contains(event.target)) {
      this.remove();
    }
  }
}
